import { HuonekorttiRequestPut } from "@/api/models/huonekortti-request-put"
import { HuonekorttiResponse } from "@/api/models/huonekortti-response"
import { useHuonekorttiTable } from "./huonekorttiTable"
import { ElMessage, ElMessageBox, TableInstance } from "element-plus"
import {ref, toRef, watch } from "vue"
import { HuonekorttiStatusResponse } from "@/api/models/huonekortti-status-response"
import { hankePage } from "@/views/hanke"
import { useHuonekortti, useHuonekorttiUpdate } from "@/methods/huonekorttiComposablses"
import { huonekorttiListing } from "../huonekortit"
import { useCountKommentit } from "@/methods/kommenttiComposables"
import kommenttiTyyppi from "@/types/Kommentti"
import { useCountLiitteet } from "@/methods/liiteComposables"
import { TilaRequestPut } from "@/api/models/tila-request-put"
import { useTilaBatch } from "@/methods/tilaComposables"
import { TilaBatchRequest, TilaBatchRequestOperationEnum } from "@/api/models/tila-batch-request"
import _ from "lodash"

export function huonekorttiTableEditable() {
    const { id, hankeVastuuyksikot, tilanimikkeet, writableVastuuyksikot, paakayttaja, resetTilanumero } = hankePage()
    const { huonekortit, sort, sortChanged, updateHuonekortit, addTila, deleteHuonekortti } = huonekorttiListing()
    const { batchTilat, error: tilaBatchError, loading: tilaBatchLoading, response: tilaBatchResponse } = useTilaBatch()
    const { formatTilat } = useHuonekorttiTable()
    const edit = ref()
    const editedHuonekortti = ref<HuonekorttiRequestPut>({} as HuonekorttiRequestPut)
    const { huonekortti } = useHuonekortti(edit)
    const { updateHuonekortti, response, loading, error  } = useHuonekorttiUpdate()
    const mallihuonekortti = ref<HuonekorttiResponse>()
    const mallihuonekorttiDialog = ref(false)
    const tableRef = ref<TableInstance>()
    const huonekorttiIds = ref<number[]>()
    const { count: kommentitCount } = useCountKommentit(huonekorttiIds, toRef(1 as kommenttiTyyppi))
    const { count: liiteetCount } = useCountLiitteet(huonekorttiIds, toRef(1 as kommenttiTyyppi))
    const removedTilat = ref<TilaRequestPut[]>([])
    const batchedTilat = ref<{ huonekorttiId: number | undefined, request: TilaBatchRequest[] }>({ huonekorttiId: undefined, request: [] })

    const checkPoistoOikeus = (val: HuonekorttiResponse) => {
        if (val.status == HuonekorttiStatusResponse.Hyvaksytty && paakayttaja) {
            return true
        } else if (
            val.status != HuonekorttiStatusResponse.Hyvaksytty &&
            writableVastuuyksikot.value?.some((v) => v?.id == val.vastuuyksikko.id)
        ) {
            return true
        } else {
            return false
        }
    }
    const editHuonekortti = (item: HuonekorttiResponse) => {
        editedHuonekortti.value = _.cloneDeep(item)
        edit.value = item.id
        batchedTilat.value.request = []
        removedTilat.value = []
    }
    const cancelEdit = () => {
        updateHuonekortit()
        resetTilanumero()

        edit.value = undefined
    }
    const saveEdit = (item: HuonekorttiResponse) => {
        if (
            item.vastuuyksikko?.id &&
            item.tilanimike?.id &&
            item.tilat &&
            item.tilat.length > 0 &&
            item.id &&
            huonekortti.value
        ) {
            setBachedTilat(huonekortti.value.id)

            editedHuonekortti.value.toiminnanKuvaus = huonekortti.value.toiminnanKuvaus
            editedHuonekortti.value.toiminnanVaatimukset = huonekortti.value.toiminnanVaatimukset
            editedHuonekortti.value.henkilomaaraNorm = huonekortti.value.henkilomaaraNorm
            editedHuonekortti.value.henkilomaaraMax = huonekortti.value.henkilomaaraMax
            editedHuonekortti.value.sahkoluokka = huonekortti.value.sahkoluokka
            editedHuonekortti.value.toimintaAika = huonekortti.value.toimintaAika

            updateHuonekortti(item.id, editedHuonekortti.value)
        }
    }
    const deleteHuonekorttiClick = (value: HuonekorttiResponse) => {
        ElMessageBox.confirm("Haluatko varmasti poistaa huonekortin: " + value.tilanimike?.nimi).then(
            () => {
                if (value.id) {
                    deleteHuonekortti(value.id)
                }
            }
        ).catch(() => {
        })
    }
    const addMallihuonekorttiClick = (val: HuonekorttiResponse) => {
        mallihuonekortti.value = val
        mallihuonekorttiDialog.value = true
    }
    const getKommentitCount = (id: number) => {
        return kommentitCount.value?.find((v) => v.id == id)?.count
    }
    const getLiitteetCount = (id: number) => {
        return liiteetCount.value?.find((v) => v.id == id)?.count
    }
    const removeTila = (item: HuonekorttiResponse | HuonekorttiRequestPut, index: number) => {
        if (item.tilat && item.tilat.length !== 1) {
            const removed = item.tilat.splice(index, 1)[0]

            if (removed && removed.id) {
                removedTilat.value.push(removed)
            }
        } else {
            ElMessage({ message: "Huonekortilla pitää olla vähintään yksi tila!", type: "warning" })
        }
    }
    const setBachedTilat = (huonekorttiId: number) => {
        batchedTilat.value.huonekorttiId = huonekorttiId

        if (removedTilat.value.length > 0) {
            removedTilat.value.forEach((tila) => {
                batchedTilat.value.request.push({
                    operation: TilaBatchRequestOperationEnum.Delete,
                    data: tila
                })
            })
        }
        if (editedHuonekortti.value.tilat && editedHuonekortti.value.tilat.length > 0 && huonekortti.value) {
            editedHuonekortti.value.tilat.forEach((tila) => {
                if(tila.id
                    && (tila.pintaAla != huonekortti.value.tilat?.find((v) => v.id == tila.id)?.pintaAla
                    || tila.tilatunnus != huonekortti.value.tilat?.find((v) => v.id == tila.id)?.tilatunnus)
                ) {

                    batchedTilat.value.request.push({
                        operation: TilaBatchRequestOperationEnum.Update,
                        data: tila
                    })
                } 
                if(!tila.id) {
                    batchedTilat.value.request.push({
                        operation: TilaBatchRequestOperationEnum.Insert,
                        data: tila
                    })
                }
            })
        }
    }

    watch(id, () => {
        if (id.value) {
            tableRef.value?.sort(sort.value.prop, sort.value.order.toString())
        }
    })
    watch(loading, (value) => {
        if(!value && response.value) {
            if(batchedTilat.value.request.length > 0 && batchedTilat.value.huonekorttiId) {
                batchTilat(batchedTilat.value.huonekorttiId, batchedTilat.value.request)
            }

            ElMessage({ message: "Huonekortti tallennettu!", type: "success" })
    
            edit.value = undefined
        }
        if(!value && error.value) {
            ElMessage({ message: "Huonekortin tallennus epäonnistui!", type: "error" })
        }
    })
    watch(tilaBatchLoading, (value) => {
        if(!value && tilaBatchResponse.value) {
            ElMessage({ message: "Tilojen muutokset tallennettu!", type: "success" })
        }
        if(!value && tilaBatchError.value) {
            ElMessage({ message: "Tilojen tallennus epäonnistui!", type: "error" })
        }
    })
    watch(huonekortit, (value) => {
        if (value) {
            huonekorttiIds.value = value.map((v) => v.id)
        }
    })
    
    return {
        huonekortit,
        edit,
        tilanimikkeet,
        hankeVastuuyksikot,
        mallihuonekorttiDialog,
        paakayttaja,
        writableVastuuyksikot,
        mallihuonekortti,
        sort,
        tableRef,
        editedHuonekortti,
        kommentitCount,
        liiteetCount,
        sortChanged,
        formatTilat,
        checkPoistoOikeus,
        addTila,
        removeTila,
        editHuonekortti,
        cancelEdit,
        saveEdit,
        addMallihuonekorttiClick,
        deleteHuonekorttiClick,
        getKommentitCount,
        getLiitteetCount
    }
}
